import { render } from "./SliderTable.vue?vue&type=template&id=56bb83f2"
import script from "./SliderTable.vue?vue&type=script&lang=js"
export * from "./SliderTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__